const scrollToTopBtn = document.querySelector('.scroll-to-top-btn');
const topElement = document.getElementById('main-content');

function handleScroll() {
    const viewportHeight = window.innerHeight;

    if (window.scrollY >= viewportHeight) {
        scrollToTopBtn.classList.add('show-btn');
    } else {
        scrollToTopBtn.classList.remove('show-btn');
    }
}

function scrollToTop() {
    topElement.scrollIntoView({
        behavior: 'smooth',
    });
}

if (scrollToTopBtn && topElement) {
    window.addEventListener('scroll', handleScroll);

    scrollToTopBtn.addEventListener('click', (event) => {
        event.preventDefault();
        scrollToTop();
    });

    handleScroll();
}
